import React, { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import Title from "./title";
import ToolsBar from "./toolsBar";
import PaginationNav from "./paginationNav";
import {
  useParams,
  Switch,
  Route,
  useLocation,
  Redirect,
  useHistory,
} from "react-router-dom";
import Navbar from "./navbar";
import logger from "utils/logger";
import util from "utils/util";
import guide from "services/guide";
import PluginDetail from "./pluginDetail";
import Releases from "./releases";
import data from "services/data";
import PluginVerModal from "./modals/pluginVerModal";
import ConfirmModal from "./modals/confirmModal";
import Filter from "./filter";
import DatePicker from "./datePicker";
import Button from "./button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo,faFilter } from "@fortawesome/free-solid-svg-icons";
import notifier from "utils/notifier";
import http from "utils/http";
import { Table, Button as BTN,Drawer,Popover } from 'antd';
import moment from "moment";
import ToolGroup from "./toolGroup";
import { hoverTips } from "utils/mixin";

const StyledFilterButton = styled.div`
  display: inline-block;
  padding: 0 5px;
  cursor: pointer;
  color: ${({ theme }) => theme.black};
  opacity: 0.7;
  transition: 0.2s;
  margin-top: -2px;
  
  ${({ theme, tips,}) =>
    hoverTips(theme, tips)};
    
  :hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }
`;
const StyledFilterItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;
const StyledFilterItem = styled.div`
  white-space: nowrap;
  cursor: pointer;
  padding: 5px;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme }) => theme.black};
  transition: 0.2s;
  :hover {
    background-color: ${({ theme }) => theme.weakGray};
  }
`;

const FilterItems = ({
  items = [],
  onSelectItem = (item) => logger.log("过滤条件：", item),
}) => {
  return (
    <StyledFilterItems>
      {items.map((item, index) => (
        <StyledFilterItem key={item.value} onClick={() => onSelectItem(item)}>
          {item.desc}
        </StyledFilterItem>
      ))}
    </StyledFilterItems>
  );
};

const StyledPluginVer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const StyledMain = styled.main`
  background-color: ${({ theme }) => theme.secondBackgroundColor};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 50px;
`;

const StyledSection = styled.section`
  width: 100%;
  min-height: 400px;
  word-wrap: break-word;
  text-align: justify;

  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

const StyledFilterContainer = styled.div`
  display: flex;
  column-gap: 25px;
`;

const StyledDatePickerGroup = styled.div`
  display: flex;
  column-gap: 7px;
  align-items: center;
`;

const StyledIcon = styled(FontAwesomeIcon)``;

const tablePageSize = 20;

const flagFilterItems = data.flagFilterItems;
const defaultFlagFilterItem = data.defaultFlagFilterItem;
const systemFilterItems = data.systemFilterItems;
const defaultSystemFilterItems = data.defaultSystemFilterItems;

let cancelSources = [];

const PluginVer = ({ user }) => {
  const [pluginInfo, setPluginInfo] = useState(null);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [flagFilterItem, setFlagFilterItem] = useState(defaultFlagFilterItem);
  const [systemFilterItem, setSystemFilterItem] = useState(defaultSystemFilterItems);
  const [publishDateStart, setPublishDateStart] = useState(null);
  const [publishDateEnd, setPublishDateEnd] = useState(null);
  const [list, setList] = useState([]);
  const [modalVisible, setModalVisible] = useState({
    pluginInfoModal: false,
    confirmModal: false,
  });
  const [modalType, setModalType] = useState("");
  const [confirmModalType, setConfirmModalType] = useState("pluginVer");
  const [currentPluginVer, setCurrentPluginVer] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [moduleInfo, setModuleInfo] = useState([]);
  const [tableSelectedRows, setTableSelectedRows] = useState([]);
  const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentPageSize, setCurrentPageSize] = useState(20);
  const { search } = useLocation();
  const [open, setOpen] = useState(false);
  const [currentPluginInfo, setCurrentPluginInfo] = useState(false);
  const [moudleFilterItems,setMoudleFilterItems] = useState([])
  const [moduleFilterItem, setModuleFilterItem] = useState({value: 'all',desc: '全部'});
  const [moduleFilterVisible, setModuleFilterVisible] = useState(false);
  
  const handleOpenChange = (newOpen) => {
    console.log('newOpen',newOpen)
    setModuleFilterVisible(newOpen);
  };
  const onClose = () => {
    setOpen(false);
  };
  // const appId = util.qsParse(search).appId;

  const closeAllModal = useCallback(() => {
    setModalVisible({});
    // 清空错误信息
    setErrorMessage("");
    // 取消队列中的请求
    if (cancelSources.length > 0) {
      // 将全部搜索请求取消
      cancelSources.forEach((cancelSource) => {
        cancelSource.cancel("cancel");
      });
      // 重置
      cancelSources = [];
    }
  }, []);

  // 获取插件的信息, 就是插件的信息 不是插件版本的信息
  const getPluginInfo = useCallback(async (appId) => {
    if (!appId) return;
    try {
      const plugin = await data.getPluginInfoByAppId(appId);
      console.log('plugin',plugin);
      setPluginInfo(plugin);
    } catch (e) {
      notifier.error(e.message);
    }
  }, []);
  // 获得插件版本列表
  const getPluginVerList = useCallback(
    async (pageSize, currentPage) => {
      const systemFilter = systemFilterItem.value;
      const publishFlag = flagFilterItem.value;
      const publishTimeStart = publishDateStart?.getTime() || "";
      const publishTimeEnd = publishDateEnd?.getTime() || "";
      const pluginAppId = moduleFilterItem.value === "all" ? "" : moduleFilterItem.value;
      // const { payload } = await data.getHistoryVer()
      // setList(payload.plugin_ver_list);
      // console.log("所有插件版本的列表信息",payload.plugin_ver_list);
      try {
        const { totalCount, pluginVerList } =
          await data.getHistoryVer({
            pluginAppId,
            pageSize,
            currentPage,
            keyword,
            publishFlag,
            publishTimeStart,
            publishTimeEnd,
            systemFilter
          });
        // getPluginInfo(pluginAppId);
        setList(pluginVerList);
        console.log('pluginVerList',pluginVerList);
        setTotal(totalCount);
      } catch (e) {
        notifier.error(e.message);
      }
    },
    [flagFilterItem, keyword, publishDateEnd, publishDateStart,systemFilterItem,moduleFilterItem]
  );

  const handleCurrentPageChange = useCallback(
    (pageNum) => {
      setCurrentPage(pageNum);
      getPluginVerList(tablePageSize, pageNum);
    },
    [getPluginVerList]
  );

  const handleSearch = useCallback(() => {
    if (currentPage === 1) {
      getPluginVerList(tablePageSize, 1);
    } else {
      setCurrentPage(1);
    }
  }, [currentPage, getPluginVerList]);

  const handleFileUpload = useCallback(async (file, onFileUpload) => {
    if (!file) return;
    const cancelSource = http.source();
    cancelSources.push(cancelSource);
    try {
      const { fileId } = await data.uploadFile(
        file,
        cancelSource.token,
        onFileUpload
      );
      // if (fileId) callBack && callBack(true, fileId);
      return [true, fileId, "上传完成"];
    } catch (error) {
      logger.log(error);
      let msg = error.message;
      if (msg === "cancel") {
        msg = "已取消文件上传请求";
      }
      notifier.error(msg);
      return [false, "", error.message];
    }
  }, []);
  // 处理插件版本上传的函数
  const handlePluginVerAdd = useCallback(
    async (form) => {
      try {
        await data.addPluginVer(form);
        // 关闭modal
        closeAllModal();
        // 转到第一页
        getPluginVerList(tablePageSize, 1);
        return true;
      } catch (error) {
        // setErrorMessage(error.message);
        notifier.error(error.message);
      }
    },
    [closeAllModal, getPluginVerList]
  );

  const handlePluginVerUpdate = useCallback(
    async (id, form) => {
      try {
        await data.updatePluginVer(id, form);
        // 关闭modal
        closeAllModal();
        // 刷新当前页
        getPluginVerList(tablePageSize, currentPage);
        return true;
      } catch (error) {
        // setErrorMessage(error.message);
        notifier.error(error.message);
      }
    },
    [closeAllModal, currentPage, getPluginVerList]
  );

  const handlePluginVerDelete = useCallback(async () => {
    try {
      await data.deletePluginVer(currentPluginVer.id);
      // 关闭modal
      closeAllModal();
      // 刷新当前页
      getPluginVerList(tablePageSize, currentPage);
    } catch (error) {
      // setErrorMessage(error.message);
      notifier.error(error.message);
    }
  }, [closeAllModal, currentPage, currentPluginVer, getPluginVerList]);

  const handleFileDelete = useCallback(async () => {
    try {
      await data.deleteFile(currentFile.fileId);
      // 关闭modal
      closeAllModal();
      // 刷新当前页
      getPluginVerList(tablePageSize, currentPage);
    } catch (error) {
      // setErrorMessage(error.message);
      notifier.error(error.message);
    }
  }, [closeAllModal, currentFile, currentPage, getPluginVerList]);

  const reloadCurrentPage = useCallback(async () => {
    // 刷新当前页
    getPluginVerList(tablePageSize, currentPage);
  }, [currentPage, getPluginVerList]);

  const handleFilterSelect = useCallback((item) => {
    logger.log("选择了过滤条件: ", item);
    setFlagFilterItem(item);
  }, []);
  const handleSystemFilterSelect = useCallback((item) => {
    logger.log("选择了过滤条件: ", item);
    setSystemFilterItem(item);
  }, []);
  const handleModuleFilterSelect = useCallback((item) => {
    logger.log("选择了过滤条件: ", item);
    setModuleFilterItem(item)
    setModuleFilterVisible(false)
  }, []);

  const resetPublishDate = useCallback(() => {
    setPublishDateStart(null);
    setPublishDateEnd(null);
  }, []);

  // 根据name获取插件信息
  useEffect(() => {
    // getPluginInfo(appId);
    getPluginVerList(tablePageSize, 1);
  }, [getPluginInfo, flagFilterItem, publishDateStart, publishDateEnd,systemFilterItem,moduleFilterItem]);

  const getMoudleInfo = async () => {
    const moduleInfo = await data.getPluginInfoList(50,1)
    const moudleFilterItems = moduleInfo.pluginList.map(item => {
      return {
        value: item.appId,
        desc: `${item.module}(${item.aliasName})`
      }
    })
    moudleFilterItems.unshift({value: 'all', desc: '全部'})
    setMoudleFilterItems(moudleFilterItems)
    setModuleInfo(moduleInfo.pluginList)
  }
  useEffect(() => {
    getMoudleInfo()
  },[]);  

  const handleTableSeletion = (selectedRowKeys, selectedRows) => {
    // 在这里存储要删除的插件版本的信息
    setTableSelectedRows(selectedRows)
    if(selectedRows.length === 0) return setDeleteBtnDisabled(true)
    setDeleteBtnDisabled(false)
  }
  const handleDelete = () => {
    // 弹出确认删除的对话框
    setModalVisible({ confirmModal: true });
    setConfirmModalType("mutiPluginVer");
  }

  // 弹窗点击了确认之后的删除逻辑
  const handleMutiPluginVerDelete = async () => {
    let isSelectAll = false
    // 关闭弹窗
    closeAllModal();
    // 开启loading状态
    setLoading(true)
    // 判断本页的内容是否全部删除 如果是全部删除则返回上一页
    if(tableSelectedRows.length === currentPageSize) isSelectAll = true
    if(total % currentPage <= currentPageSize && total - currentPageSize * (currentPage - 1) === tableSelectedRows.length) isSelectAll = true
    for(let i = 0; i < tableSelectedRows.length; i++) {
      await data.deletePluginVer(tableSelectedRows[i].id)
    }
    setLoading(false)
    // 判断 删除之后本页是否为空 不一致返回上一页
    if(isSelectAll) {
      return getPluginVerList(tablePageSize, currentPage - 1 === 0 ? 1 : currentPage - 1);
    }
    getPluginVerList(tablePageSize, currentPage);
  }
  
  // 分页器页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
  const handlePaginationChange = useCallback((page, pageSize) => {
    setCurrentPage(page)
    setCurrentPageSize(pageSize)
    getPluginVerList(pageSize,page)
  },[getPluginVerList])

  // 删除确认框的变体
  const deleteConfirmModalTypes = {
    pluginVer: {
      content: "确定要删除该插件版本？",
      onConfirm: handlePluginVerDelete,
    },
    file: {
      content: "确定要删除该文件？",
      onConfirm: handleFileDelete,
    },
    mutiPluginVer: {
      content: "确定要删除选中的插件版本？",
      onConfirm: handleMutiPluginVerDelete,
    }
  };

  const history = useHistory();

  // // 这里跳转的时候会报错？
  // if (!appId) {
  //   logger.log("未选择插件", search, appId);
  //   history.push(guide.defaultPath);
  //   return <></>;
  // }

  const tools = [
    {
      type: "update",
      onClick: (data) => {
        setModalType("update");
        setModalVisible({ pluginVerModal: true });
        logger.log("点击了修改 当前点击的插件版本：", data);
        setCurrentPluginVer(data);
      },
    },
    {
      type: "remove",
      onClick: (data) => {
        setModalType("");
        setModalVisible({ confirmModal: true });
        logger.log("点击了删除 当前点击的插件版本：", data);
        setCurrentPluginVer(data);
        setConfirmModalType("pluginVer");
      },
    },
    {
      type: "detail",
      onClick: (data) => {
        // 打开详情的抽屉
        setCurrentPluginInfo(data)
        setOpen(true)
      },
    },
  ]

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      align: 'center',
      key: 'id'
    },
    {
      title: '模块',
      dataIndex: 'pluginAppId',
      align: 'center',
      key: 'pluginAppId',
      render: (pluginAppId) => {
        const module = moduleInfo.find((item) => item.appId === pluginAppId)?.module
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden'}} title={module}>
          {module}
        </div>)
      }
    },
    {
      title: '版本号',
      dataIndex: 'version',
      align: 'center',
      key: 'version',
      render: (version,record) => {
        return (
          <div 
            style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',cursor: 'pointer'}} 
            title={version}
            onClick={() => {
              setCurrentPluginInfo(record)
              setOpen(true)
            }}
          >
            {version}
          </div>)
      }
    },
    {
      title: '发布标志',
      dataIndex: 'publishSystem',
      align: 'center',
      key: 'publishSystem',
      render: (publishSystem, row) => {
        const flag =`${publishSystem} - ${row.publishFlag === 1 ? '正式版' : '测试版'}`
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '120px'}} title={flag}>
            {flag}
          </div>
        )
      },
    },
    {
      title: '编译时间',
      dataIndex: 'buildTime',
      align: 'center',
      key: 'buildTime',
      render: (buildTime) => {
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '138px'}} title={buildTime}>
            {buildTime}
          </div>
        )
      }
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      align: 'center',
      key: 'publishTime',
      render: (time) => {
        const publishTime = moment(time).format('YYYY-MM-DD HH:mm:ss')
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '138px'}} title={publishTime}>
            {publishTime}
          </div>
        )
      }
    },
    {
      title: '描述',
      dataIndex: 'changeInfo',
      align: 'center' ,
      key: 'changeInfo',
      render: (changeInfo) => {
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '200px'}} title={changeInfo}>
          {changeInfo}
        </div>)
      }
    },
    {
      title: 'desc',
      dataIndex: 'changeInfoEn',
      align: 'center' ,
      key: 'changeInfoEn',
      render: (changeInfoEn) => {
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '120px'}} title={changeInfoEn}>
          {changeInfoEn}
        </div>)
      }
    },
    {
      title: '操作',
      align: 'center' ,
      key: 'operate',
      render: (record) => {
        return <ToolGroup auth={!!user} tools={tools} data={record}/>
      }
    },
  ];

  return (
    <StyledPluginVer>
      <StyledMain>
        <Title title='历史版本' />
        <StyledSection>
            <ToolsBar
              auth={!!user}
              tools={[]}
              search={{
                value: keyword,
                setValue: setKeyword,
                onSearch: handleSearch,
              }}
            />
            <StyledFilterContainer>
              <Filter
                padding="7px"
                items={flagFilterItems}
                itemDesc={flagFilterItem.desc}
                onSelectItem={handleFilterSelect}
              />
              <Filter
                padding="7px"
                items={systemFilterItems}
                itemDesc={systemFilterItem.desc}
                onSelectItem={handleSystemFilterSelect}
                selectName = '系统'
              />
              <div style={{display: "flex", alignItems: "center"}}>
                <Popover
                  content={
                    <FilterItems items={moudleFilterItems}  onSelectItem={handleModuleFilterSelect}/>
                  }
                  overlayClassName="filter-popover"
                  visible={moduleFilterVisible}
                  trigger="click"
                  onVisibleChange={handleOpenChange}
                >
                  <StyledFilterButton
                    tips={"选择过滤条件"}
                  >
                    <FontAwesomeIcon icon={faFilter}/>
                  </StyledFilterButton>
                  </Popover>
                <span style={{fontSize: "14px",color: "#586069",userSelect: 'none'}}>模块:</span>
                <span style={{fontSize: "14px",fontWeight: 600,marginLeft: "5px"}}>{moduleFilterItem.desc}</span>
              </div>
              <StyledDatePickerGroup title="按发布时间筛选">
                <DatePicker
                  id="1"
                  placeholder="开始日期"
                  date={publishDateStart}
                  setDate={setPublishDateStart}
                />
                —
                <DatePicker
                  id="2"
                  placeholder="结束日期"
                  date={publishDateEnd}
                  setDate={setPublishDateEnd}
                />
                <Button
                  onClick={resetPublishDate}
                  marginTop="0"
                  messageArea={false}
                  title="重置日期"
                >
                  <StyledIcon icon={faUndo} />
                </Button>
              </StyledDatePickerGroup>
              <BTN onClick={handleDelete} disabled={deleteBtnDisabled} className="historyVerStyle">删除</BTN>
            </StyledFilterContainer>
            <Table 
              rowKey={record => record.id}
              loading={loading}
              dataSource={list} 
              columns={columns}
              rowSelection={{type: 'checkbox',onChange: handleTableSeletion,columnWidth: 30}}
              pagination={{ position: ["bottomCenter"] ,defaultPageSize: 20,pageSizeOptions:['20','50'],showSizeChanger: true,total, onChange: handlePaginationChange}}
            />
            <Drawer title="插件详情" onClose={onClose} visible={open} width={850}>
              <Releases
                auth={!!user}
                list={[currentPluginInfo]}
                module={pluginInfo?.module}
                tools={[
                  {
                    type: "update",
                    onClick: (data) => {
                      setModalType("update");
                      setModalVisible({ pluginVerModal: true });
                      logger.log("点击了修改 当前点击的插件版本：",  );
                      setCurrentPluginVer(data);
                    },
                  },
                  {
                    type: "remove",
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的插件版本：", data);
                      setCurrentPluginVer(data);
                      setConfirmModalType("pluginVer");
                    },
                  },
                ]}
                fileTools={[
                  {
                    type: "remove",
                    title: "删除文件",
                    titlePosition: { left: "-70px", top: "0" },
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的文件：", data);
                      setCurrentFile(data);
                      setConfirmModalType("file");
                    },
                  },
                ]}
                reload={reloadCurrentPage}
              />
            </Drawer>
            <PluginVerModal
              module={pluginInfo?.module}
              errorMessage={errorMessage}
              pluginAppId={currentPluginVer?.pluginAppId}
              visible={modalVisible.pluginVerModal}
              type={modalType}
              displayTargetPlugin
              data={currentPluginVer}
              onClose={closeAllModal}
              onFileUpload={handleFileUpload}
              onPluginVerAdd={handlePluginVerAdd}
              onPluginVerUpdate={handlePluginVerUpdate}
            />
            <ConfirmModal
              errorMessage={errorMessage}
              visible={modalVisible.confirmModal}
              onClose={closeAllModal}
              title="提示"
              content={deleteConfirmModalTypes[confirmModalType]?.content}
              confirmLabel="删除"
              cancelLabel="取消"
              confirmType="danger"
              onConfirm={deleteConfirmModalTypes[confirmModalType]?.onConfirm}
              onCancel={closeAllModal}
            />
          {/* <Redirect exact from={guide.pluginVerBasePath} to={guide.defaultPluginVerPath} /> */}
        </StyledSection>
      </StyledMain>
    </StyledPluginVer>
  );
};

export default PluginVer;
